import React, { useEffect, useState, useContext } from "react";
import "./VoyahTaishanWarranty.css";

import drivingModes from "../../../../assets/images/voyahtaishan/drivingModes.png";

import { LanguageContext } from "../../../../context/LanguageContext";
import { getPageContent } from "../../../../api/publicContent.api";

const VoyahTaishanWarranty = () => {
  const { currentLang } = useContext(LanguageContext);

  const [warranty, setWarranty] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadContent = async () => {
      try {
        setLoading(true);
        const response = await getPageContent("voyahtaishan", currentLang);
        setWarranty(response.sections?.warranty || null);
      } catch (err) {
        console.error("Failed to load Voyah Taishan warranty", err);
      } finally {
        setLoading(false);
      }
    };

    loadContent();
  }, [currentLang]);

  if (loading) return null;

  return (
    <section className="voyahtaishan-warranty-section">
      {warranty?.subtitle || warranty?.main_text ? (
        <div className="voyahtaishan-warranty-header">
          {warranty.subtitle ? (
            <p className="voyahtaishan-warranty-sub">{warranty.subtitle}</p>
          ) : null}
          {warranty.main_text ? (
            <p className="voyahtaishan-warranty-main">{warranty.main_text}</p>
          ) : null}
        </div>
      ) : null}

      <div className="voyahtaishan-warranty-modes-line">
        <img src={drivingModes} alt="Driving modes" />
        <div className="voyahtaishan-elipse" />
      </div>
    </section>
  );
};

export default VoyahTaishanWarranty;
